<template>
   <div class="share-fail">
       <div class="content">
           <div class="icon">
               <img src="@/assets/img/task-cancel.svg">
           </div>
           <div class="title">
               連結已失效，
           </div>
           <div class="title">
               您無法觀看任務進度。
           </div>
           <div class="button" v-show="isMobile" @click="download">
               <img src="@/assets/img/download.svg">
               下載App
           </div>
           <router-link :to="{name: 'home'}" tag="div" class="home">
               前往首頁
               <img src="@/assets/img/next-white.svg">
           </router-link>
       </div>
   </div>
</template>

<script>
    export default {
        name: "ShareFail",
        computed: {
            isMobile() {
                if(! /AppleWebKit.*Mobile/i.test(navigator.userAgent) &&
                    ! /MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(navigator.userAgent) &&
                    ! /Android|webOS|iPhone|iPod|BlackBerry|iPad/i.test(navigator.userAgent)){
                    return false;
                }

                return true;
            },
        },
        methods: {
            download() {
                if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                    window.open('https://apps.apple.com/tw/app/id1470204005', "_blank");
                } else if (/(Android)/i.test(navigator.userAgent)) {
                    window.open('https://play.google.com/store/apps/details?id=tw.com.paopaotui.consumer', "_blank");
                } else {
                    window.open('https://paopaotui.com.tw/', "_blank");
                };
            }
        }
    }
</script>

<style lang="scss" scoped>
    .share-fail {
        background-color: #4a4a4a;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;

        .content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .icon {
                user-select: none;
                img {
                    width: 140px;
                    height: 140px;;
                }
            }

            .title {
                color: #FFFFFF;
                font-size: 20px;
                letter-spacing: 0;
                line-height: 28px;
                text-align: center;
            }

            .button {
                margin-top: 20px;
                color: #FFFFFF;
                font-size: 16px;
                letter-spacing: 0;
                line-height: 22px;
                text-align: center;
                background-color: #339933;
                padding: 5px 15px;
                border-radius: 16px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                user-select: none;

                img {
                    margin-right: 5px;
                }
            }

            .home {
                margin-top: 80px;
                color: #FFFFFF;
                font-size: 16px;
                letter-spacing: 0;
                line-height: 22px;
                text-align: center;
                display: flex;
                justify-content: center;
                align-content: center;
                cursor: pointer;
                user-select: none;

                img {
                    height: 25px;
                    width: 25px;
                }
            }
        }
    }
</style>